// extracted by mini-css-extract-plugin
export default {"product-info-section":"hA_jUBcngYEmFu0WHKWA","section-title":"fok6BgRME_XyZu0xDDu5","divider-wrapper":"LPYzCLJhl6sxHu2PSeHg"};